import React from 'react';
import PropTypes from 'prop-types';
import styles from './OverviewBenefits.module.less';

const BenefitCard = ({ card }) => {
  const { icon, key, badge } = card;

  return (
    <div className={styles.benefit_card}>
      <img className={styles.benefit_logo} src={icon} alt="" />
      <p className={styles.benefit_title}>{key}</p>
      <p className={styles.benefit_description}>{badge}</p>
    </div>
  );
};

BenefitCard.propTypes = {
  icon: PropTypes.string,
  title: PropTypes.string,
  badge: PropTypes.string
};
BenefitCard.defaultProps = { content: null };

export default BenefitCard;
